import utils from '@/utils/utils'
import { flattenDeep } from 'lodash-es'
//
// initial state
const state = {
  brands: [],
  categories: [1],
  contentId: 0,
  colors: [],
  models: [],
  surfaces: [],
  safetyClassifications: [],
  doors: [],
  windows: [],
  pageIndex: getPageIndex(),
  sortBy: null
}

function getPageIndex() {
  const searchString = utils.getSearchString()
  const queryStringParams = new URLSearchParams(searchString)

  // Get data from search string else set it to default (1)
  const data = (!queryStringParams.get('pageIndex') || queryStringParams.get('pageIndex').length < 1)
    ? 1
    : parseInt(queryStringParams.get('pageIndex'))
  return data
}

// getters
const getters = {
  filterParams: (state) => {
    let sortObj = {}

    if (state.sortBy != null) {
      switch (state.sortBy) {
      case 'PriceAsc':
        sortObj.OrderByPrice = true
        break
      case 'PriceDesc':
        sortObj.OrderByPriceDescending = true
        break
      //
      case 'AlphabeticallyAsc':
        sortObj.OrderByName = true
        break
      //
      case 'AlphabeticallyDesc':
        sortObj.OrderByNameDescending = true
        break
      default:
        break
      }
    } else {
      sortObj.DefaultOrder = true
    }

    function transformValue (value) {
      let transformedValue = []

      for (let index = 0; index < value.length; index++) {
        const element = value[index]
        transformedValue.push(utils.getTypedValue(element))
      }

      return flattenDeep(transformedValue)
    }

    return {
      Suppliers: transformValue(state.brands),
      Categories: transformValue(state.categories),
      Colors: transformValue(state.colors),
      ContentId: state.contentId,
      GarageModels: transformValue(state.models),
      GarageSurfaces: transformValue(state.surfaces),
      DoorClassifications: transformValue(state.safetyClassifications),
      DoorModels: transformValue(state.doors),
      DoorGlasses: transformValue(state.windows),
      PageIndex: state.pageIndex,
      ...sortObj
    }
  }
}

// actions
const actions = {
  setFilter ({ state, commit }, filterItem) {
    commit('setFilter', filterItem)
  },

  addFilter ({ state, commit }, filterItem) {
    commit('addFilter', filterItem)
  },

  removeFilter ({ commit }, filterItem) {
    commit('removeFilter', filterItem)
  },

  clearFilter ({ commit }, filterItem) {
    commit('clearFilter', filterItem)
  },
}

// mutations
const mutations = {
  setFilter (state, payload) {
    if (Array.isArray(payload)) {
      for (let index = 0; index < payload.length; index++) {
        const item = payload[index]
        state[item.type] = item.value
      }
    } else {
      state[payload.type] = payload.value
    }
  },

  addFilter (state, payload) {
    state[payload.type].push(...payload.value)
    state.pageIndex = 1
  },

  removeFilter (state, payload) {
    state[payload.type].splice(state[payload.type].indexOf(...payload.value), 1)
    state.pageIndex = 1
  },

  clearFilter (state, payload) {
    state[payload.type].splice(0, state[payload.type].length)
    state.pageIndex = 1
  },
}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}
